import React, { useState } from "react";
import { Card, Form, Input, Button, message } from "antd";
import axios from '../util/axiosConfig';
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom"; 

const ResetPWD: React.FC = () => {
    const { user, logout } = useAuth();
    const [resetForm] = Form.useForm();
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const token = user?.token;
    const navigate = useNavigate(); 

    const handleSubmit = async (values: any) => {
        try {
            const payload = {
                currentPassword: values.currentPassword,
                token: token,
                password: values.newPassword
            };

            const response = await axios.post('/api/v1/user/reset-password', payload);
            const data = response.data;

            if (data.error === "User first login token expired") {
                message.error("Your login token has expired. Logging out...");
                logout(); 
            } else if (data.error) {
                message.error(data.error || "Failed to reset password. Please try again.");
            } else if(data.message) {
                message.success("Password reset successfully! Redirecting to login...");
                navigate("/login"); 
            }
        } catch (error) {
            console.error("Error during password reset:", error);
            message.error("An unexpected error occurred. Please try again.");
        }
    };

    const handlePasswordChange = () => {
        const newPassword = resetForm.getFieldValue("newPassword");
        const confirmPassword = resetForm.getFieldValue("confirmPassword");

        if (newPassword && confirmPassword && newPassword === confirmPassword) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    };

    return (
        <>
            <Card
                bordered={false}
                title={'Reset Password'}
                style={{
                    minHeight: '85vh'
                }}
            >
                <Card className="reset-card" bordered={false}>
                    <Form
                        form={resetForm}
                        onFinish={handleSubmit}
                        layout="vertical"
                    >
                        <Form.Item
                            name="currentPassword"
                            label="Current Password"
                            rules={[{ required: true, message: "Please Enter your Current Password" }]}
                        >
                            <Input.Password placeholder="Enter current password" />
                        </Form.Item>
                        <Form.Item
                            name="newPassword"
                            label="New Password"
                            rules={[
                                { required: true, message: "Please Enter your New Password" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        const currentPassword = getFieldValue('currentPassword');
                                        if (!value || currentPassword === value) {
                                            return Promise.reject(new Error("New password should not be the same as the current password!"));
                                        }
                                        return Promise.resolve();
                                    }
                                })
                            ]}
                            dependencies={['currentPassword']}
                        >
                            <Input.Password
                                placeholder="Enter new password"
                                onChange={handlePasswordChange}
                            />
                        </Form.Item>
                        <Form.Item
                            name="confirmPassword"
                            label="Confirm New Password"
                            rules={[
                                { required: true, message: "Please Re-enter new Password" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error("Passwords do not match!"));
                                    }
                                })
                            ]}
                            dependencies={['newPassword']}
                        >
                            <Input.Password
                                placeholder="Confirm new password"
                                onChange={handlePasswordChange}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={isButtonDisabled}
                            >
                                Reset Password
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Card>
        </>
    );
};

export default ResetPWD;